
import ProductsList from '@/graphql/queries/products/ProductsList'

export default {
  vessel: {
    title: {
      fontSize: '2xl',
      textColor: 'black',
      lg: {
        fontSize: '3xl'
      }
    }
  },
  async fetch() {
    const { data } = await this.$graphql.query({
      clientId: 'eshop',
      query: ProductsList,
      variables: {
        where: { featured: true },
        first: 8,
        orderBy: 'sortOrder_ASC'
      }
    })

    this.products = data.nodes
  },
  computed: {
    buttonAttrs() {
      return {
        color: 'black',
        fontSize: 'md',
        padding: 'sm'
      }
    }
  }
}
